import React, { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { submitFeedback } from '../services/feedback'
import './Feedback.css'

function Feedback() {
  const [searchParams] = useSearchParams()
  const businessId = searchParams.get('businessId')
  const appointmentId = searchParams.get('appointmentId')
  const serviceId = searchParams.get('serviceId')
  const navigate = useNavigate()
  
  // Check if we're coming from booking flow (has appointmentId)
  const isFromBookingFlow = Boolean(appointmentId && serviceId)
  
  const [rating, setRating] = useState(0)
  const [hoveredRating, setHoveredRating] = useState(0)
  const [comment, setComment] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    setIsSubmitting(true)

    try {
      await submitFeedback({
        rating: rating,
        comments: comment.trim()
      })
      
      setSubmitted(true)
      
      // Redirect to confirmation page after 2 seconds
      setTimeout(() => {
        if (appointmentId && serviceId) {
          navigate(`/confirm?businessId=${businessId}&appointmentId=${appointmentId}&serviceId=${serviceId}`)
        } else {
          navigate(`/booking?businessId=${businessId}`)
        }
      }, 1000)
    } catch (error) {
      console.error('Error submitting feedback:', error)
      alert('Failed to submit feedback. Please try again.')
      setIsSubmitting(false)
    }
  }

  const handleSkip = () => {
    if (appointmentId && serviceId) {
      navigate(`/confirm?businessId=${businessId}&appointmentId=${appointmentId}&serviceId=${serviceId}`)
    } else {
      navigate(`/booking?businessId=${businessId}`)
    }
  }

  if (submitted) {
    return (
      <div className="feedback-container">
        <div className="feedback-success">
          <div className="success-icon">✓</div>
          <h2>Thank You!</h2>
          <p>Your feedback helps us improve.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="feedback-container">
      <div className="feedback-card">
        <h1>How was your booking experience?</h1>
        <p className="feedback-subtitle">Your anonymous feedback helps us improve</p>
        
        <form onSubmit={handleSubmit}>
          <div className="rating-section">
            <div className="stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  className={`star ${star <= (hoveredRating || rating) ? 'active' : ''}`}
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(0)}
                  aria-label={`Rate ${star} stars`}
                >
                  ★
                </button>
              ))}
            </div>
            {rating > 0 && (
              <p className="rating-text">
                {rating === 1 && 'Poor'}
                {rating === 2 && 'Fair'}
                {rating === 3 && 'Good'}
                {rating === 4 && 'Very Good'}
                {rating === 5 && 'Excellent'}
              </p>
            )}
          </div>

          <div className="comment-section">
            <label htmlFor="comment">Comments (optional)</label>
            <textarea
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Tell us more about your experience..."
              rows="4"
              maxLength="500"
            />
            <span className="char-count">{comment.length}/500</span>
          </div>

          <div className="button-group">
            {isFromBookingFlow && (
              <button 
                type="button" 
                className="skip-btn"
                onClick={handleSkip}
                disabled={isSubmitting}
              >
                Skip
              </button>
            )}
            <button 
              type="submit" 
              className="submit-btn"
              disabled={isSubmitting || rating === 0}
              style={!isFromBookingFlow ? { width: '100%' } : {}}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Feedback
